import { useEffect } from 'react'

import { EVENT_NAME_BEFORE_UNLOAD } from '../constants/event'
import { preventDefault } from '../utils/events'

export function useBeforeUnload(enabled = true, message, action) {
  useEffect(() => {
    if (enabled) {
      function handler(event) {
        preventDefault(event)

        if (message) {
          event.returnValue = message
        }

        if (action) {
          action()
        }

        return message
      }

      window.addEventListener(EVENT_NAME_BEFORE_UNLOAD, handler)

      return () => window.removeEventListener(EVENT_NAME_BEFORE_UNLOAD, handler)
    }
  }, [enabled, message])
}
